import { Injectable } from '@angular/core';
import { RestService } from '@abp/ng.core';
import { Observable } from 'rxjs';

export interface CurrentTermsDto {
  version: string;
}

/**
 * Asks the backend which version of the terms is currently in force.
 *
 * The registration screen quotes the answer back when it records acceptance, rather than
 * holding its own copy of the version string. A constant duplicated across two repositories
 * would eventually be bumped in one of them only, and the symptom -- people recorded as
 * accepting a document they were never shown -- is invisible until someone disputes it.
 */
@Injectable({ providedIn: 'root' })
export class TermsService {
  apiName = 'default';

  constructor(private restService: RestService) {}

  getCurrent(): Observable<CurrentTermsDto> {
    return this.restService.request<void, CurrentTermsDto>(
      { method: 'GET', url: '/api/terms/current' },
      { apiName: this.apiName }
    );
  }
}
